import React from 'react'

import { DashboardUser } from './component/dashboard-user'
import { DashboardCourse } from './component/dashboard-course'
import { DashboardAnalyticPlatform } from './component/dashboard-analytic-platform'
import { DashboardAnalyticSession } from './component/dashboard-analytic-session'
import { Grid, GridItem3 } from '../../../../../shared/chart/grid'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import { IconDashboard } from '../../../../../shared/icon/icon'
import { RoleOrgAnalytic, RoleOrgDashboard } from '../../../../../role/components/role-org'
import { FeatureAnalytic } from '../../../../../shared/component/org-feature'

// Each widget is gated on the scope its own endpoint enforces, not on the
// subject it displays. Gating has to happen HERE, at the parent: the widgets
// fetch from useLoad(..., []) on mount, so a widget that mounts and renders
// nothing still issues the request -- and a denied one is a 403 in the
// request log (audit.request_log; log_errors was retired in audit phase 6).
//
//   DashboardUser / DashboardCourse -> rapid-api-dashboard, ORG DASHBOARD
//   DashboardAnalytic*              -> rapid-api-analytics, ORG ANALYTIC
export const Organization = () => {
  return (
    <BreadcrumbView Icon={IconDashboard} text="Dashboard">
      <React.Fragment>
        <Grid>
          <RoleOrgDashboard accessRead>
            <GridItem3>
              <DashboardUser />
            </GridItem3>
            <GridItem3>
              <DashboardCourse />
            </GridItem3>
          </RoleOrgDashboard>

          <FeatureAnalytic>
            <RoleOrgAnalytic accessRead>
              <GridItem3>
                <DashboardAnalyticPlatform />
              </GridItem3>
              <GridItem3>
                <DashboardAnalyticSession />
              </GridItem3>
            </RoleOrgAnalytic>
          </FeatureAnalytic>
        </Grid>
      </React.Fragment>
    </BreadcrumbView>
  )
}
